export type BrandSlug = 'byzfunder' | 'byzwash';

export function detectBrandSlug(hostname: string, qsBrand?: string | null): BrandSlug {
  const forced = (qsBrand || '').toLowerCase();
  if (forced === 'byzwash' || forced === 'byzfunder') return forced as BrandSlug;

  const h = (hostname || '').toLowerCase();
  if (h.includes('byzwash')) return 'byzwash';
  return 'byzfunder';
}
